/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2024
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { Provider } from "react-redux";
import { Router, Switch, Route } from "react-router-dom";
import { AuthProvider } from "./helpers/authProvider";
import { IntlProvider } from "react-intl";

import getHistory from "./helpers/getHistory";
import store from "./store";
import { setAxiosStore } from "./api/axios";
import App from "../src/containers/App";
import Callback from "./components/auth/Callback";
import Logout from "./components/auth/Logout";
import LogoutCallback from "./components/auth/LogoutCallback";
import SilentRenew from "./components/auth/SilentRenew";
import ProtectedRoute from "./components/ProtectedRoute";

import "./scss/coyote.claw.scss";

// Set the store reference for axios interceptor
setAxiosStore(store);

function Root() {
  return (
      <IntlProvider locale="en">
        <Provider store={store}>
          <AuthProvider>
            <Router history={getHistory()}>
              <Switch>
                <Route exact={true} path="/signin-oidc" component={Callback} />
                <Route exact={true} path="/logout" component={Logout} />
                <Route
                  exact={true}
                  path="/logout/callback"
                  component={LogoutCallback}
                />
                <Route
                  exact={true}
                  path="/silentrenew"
                  component={SilentRenew}
                />
                <ProtectedRoute path="/" component={App} />
              </Switch>
            </Router>
          </AuthProvider>
        </Provider>
      </IntlProvider>
  );
}

export default Root;
